import { Drawer } from '@mui/material'
import { useRef } from 'react'
import StyledPaper from '/components/paper'

const PopupShell = ({ open, onClose, width = 520, children }) => {
  const focusRef = useRef(null)

  const closeMe = () =>{
    focusRef.current?.focus()
    onClose()
  }

  return (
    <>
      <Drawer
        open={open}
        anchor="right"
        onClose={closeMe}
        slotProps={{
          backdrop: { invisible: true },
          paper: {
            sx: {
              width,
              top: 64,
              height: 'calc(100% - 64px)',
              boxSizing: 'border-box',
              paddingLeft: 2.5,
              backgroundColor: 'transparent',
              backgroundImage: 'none',
              boxShadow: 'none',
            },
          },
        }}
      >
        <div className="h-full">
          <StyledPaper
            classes="h-full flex flex-col"
            sx={{
              height: 'calc(100% - 16px)',
              overflow: 'hidden',
              backgroundColor: 'table.head',
              backgroundImage: 'none',
              backdropFilter: 'none',
            }}
          >
            {children}
          </StyledPaper>
        </div>
      </Drawer>
      <div ref={focusRef} tabIndex={-1}/>
    </>
  )
}

export default PopupShell
